// extracted by mini-css-extract-plugin
module.exports = {"header":"gXYdLk","founders":"_1G-hYx","modal":"_33gdbA","shine-lines":"qKySAb"};